import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { InspirationFormComponent } from '@app/inspiration/inspiration-form/inspiration-form.component';

const routes: Routes = [
  Shell.childRoutes([
    { path: 'suggestions', component: InspirationFormComponent },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InspirationRoutingModule {}
